import instance from "./BasebAIAssistantApi";

export const getAIAssistantSettings = () => instance.get("settings/").then(({ data }) => data);
export const updateAIAssistantSettings = (enabled) => instance.patch("settings/", { enabled }).then(({ data }) => data);
export const getAIAssistantInstallation = () => instance.get("installation/").then(({ data }) => data);

export const getWebsiteSettings = () => instance.get("website/").then(({ data }) => data);
export const updateWebsiteSettings = (config) => instance.patch("website/", config).then(({ data }) => data);
export const retryWebsiteSync = () => instance.post("website/retry-sync/", {}).then(({ data }) => data);
